import { ActivityPluginRegistry } from "../../registry/ActivityPluginRegistry";
import { MessageTypes } from "../../../entities/ActivityTypes";
import { ActivityCommentCard } from "./ActivityCommentCard";

ActivityPluginRegistry.register({
  key: "1:0",
  matches: (item) => item.Entity === 1 && item.Type === MessageTypes.Comment,
  Component: ActivityCommentCard
});
